// lowest level API layer - talks directly to server
import { BILL_PAY_BACKEND } from '../constants'

export async function GetLicensedLocations() {
  const response = await fetch(`${BILL_PAY_BACKEND}/fetch-licensed-locations`)
  return response.json()
}
